import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";
import { ABOUT } from "@/data";

const AboutModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="wv-scroll max-h-[85vh] overflow-y-auto border-white/10 bg-black/90 text-white backdrop-blur-2xl sm:max-w-xl"
        data-testid="about-modal"
      >
        <DialogHeader>
          <div className="mb-1 flex items-center gap-2 text-[#FF2A6D]">
            <Sparkles className="h-5 w-5" />
            <span className="text-xs uppercase tracking-[0.25em]">About · 소개</span>
          </div>
          <DialogTitle className="font-display text-2xl tracking-tight text-white">
            {ABOUT.question}
          </DialogTitle>
          <DialogDescription className="sr-only">
            About WebtoonVerse — what future content is and why it matters.
          </DialogDescription>
        </DialogHeader>

        <p className="text-sm leading-relaxed text-white/70">{ABOUT.intro}</p>

        <div className="mt-4 space-y-4">
          {ABOUT.points.map((p, i) => (
            <div key={p.title} className="flex gap-3">
              <span
                className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-medium text-black"
                style={{
                  background: ["#FF2A6D", "#B14EDB", "#05D9E8", "#FF1E56", "#FF6B9D"][i % 5],
                }}
              >
                {i + 1}
              </span>
              <div>
                <h4 className="text-sm font-semibold text-white">{p.title}</h4>
                <p className="mt-0.5 text-sm leading-relaxed text-white/60">{p.body}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-5 rounded-2xl border border-white/10 bg-white/5 p-4 text-center text-sm text-white/70">
          <span className="kr">웹툰 속으로 들어가다</span> — passive reading becomes
          participatory storytelling.
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default AboutModal;
